export type TranslationResource = {
  title: string;
  downloading: string;
  downloadedTitle: string;
  closingCountdown: string;
  /**
   * Optional so the other locales keep compiling untouched; `t` falls back to
   * English, then to the key itself.
   */
  errorTitle?: string;
  errorHelp?: string;
  alreadyInstalledTitle?: string;
  alreadyInstalledHelp?: string;
};

export const en: TranslationResource = {
  title: 'AutoCut - Installer',
  downloading: 'Downloading AutoCut',
  downloadedTitle: 'AutoCut Downloaded Successfully !',
  closingCountdown: 'Closing in {{count}} seconds',
  errorTitle: 'Download failed',
  errorHelp: 'Please check your internet connection and open this panel again.',
  alreadyInstalledTitle: 'AutoCut is already installed',
  alreadyInstalledHelp:
    'AutoCut now runs as a desktop app. You can uninstall this extension from the Creative Cloud app.',
};
